// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1rh1u","author":"Table_author__3Px1X","authorImage":"Table_authorImage__2RIZO","unreadRow":"Table_unreadRow__3lUlc"};